<template>
  <div>
    <router-link :to="{name: 'ChangePasswordView'}">Vaihda salasanaa</router-link>
    <button v-if="this.loggedIn()" @click="logout()">Kirjaudu ulos</button>
  </div>
</template>

<script>

import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'UserInfoView',
  computed: {
    ...mapGetters('Auth', ['sessionValid', 'loggedIn']),
  },
  methods: {
    logout () {
      this.authLogout().then(() => {
        this.$router.push('/login');
      });
    },
    ...mapActions('Auth', ['authLogout']),
  },
}
</script>

<style lang="scss" scoped>

@import 'src/color.scss';
@import 'src/values.scss';

  button {
    padding: 0.3em 0.5em;
    border: 1px solid $secondary-dark;
    background: $secondary;
    color: $secondary-text;
    font-weight: bold;
    cursor: pointer;

    transition: $transition-time all;
    &:hover {
      background-color: $secondary-dark;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/UserInfoView.vue